import { api } from './index';

const BASE_PATH = '/api/internal/pricing_structures';

export interface PricingStructure {
  caregiverWeekShiftCost: number;
  caregiverWeekendShiftCost: number;
  caregiverWeekShiftCostPerHour: number;
  caregiverWeekendShiftCostPerHour: number;
  weekShiftPrice: number;
  weekendShiftPrice: number;
  weekShiftPricePerHour: number;
  weekendShiftPricePerHour: number;
  withTaxBill: boolean;
}

export const pricingStructuresApi = {
  show(patientId: number, caregiverId: number): Promise<PricingStructure> {
    return api({
      method: 'get',
      url: `${BASE_PATH}/${patientId}`,
      params: { caregiver_id: caregiverId }, // eslint-disable-line camelcase
    }).then(response => response.data.pricingStructure);
  },
};
